import React from 'react';
import ItemIndex from '../Index';

// This is a wrapper component that uses the existing ItemIndex component
// It allows the Item functionality to be embedded within the ItemDashboard tabs
function ItemSection() {
    return (
        <div>
            <ItemIndex />
        </div>
    );
}

export default ItemSection;
